import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Chart } from 'src/app/shared/utils/chart-setup';

@Component({
    selector: 'app-barras-group-admin',
    templateUrl: './barras-group-admin.component.html',
    styleUrls: ['./barras-group-admin.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BarrasGroupAdminComponent implements OnInit {
	@Input() datasetsImported: any = null;
	@Input() labelsImported: any = null;
	@Input() consultaID: any = null;
	@Input() role: any = null;
	@Output() verDetalle = new EventEmitter<{ datasetIndex: number; index: number }>();
	@ViewChild('chartCanvas', { static: false }) chartCanvas: ElementRef<HTMLCanvasElement>;

	chart: any = null;
	labels: any[] = [];
	datasets: any[] = [];

	private readonly CHART_COLORS: string[] = [
		'#002554',   // $primary-color
		'#00c4b3',   // $secondary-color
		'#05907E',   // $green-color
		'#091a7a',   // $blue-color
		'#ffc94d',   // $yellow-color
		'#ff3d71',   // $red-color
		'#7F00FF',   // $violet-color
		'#4ac9b4',   // $bright-green-color
		'#b6c7fb',   // $lighter-blue-color
		'#667c98',   // $color-fondo-modal
		'#e76f51',   // Burnt Sienna
		'#f4a261',   // Sandy Brown
	];

	private readonly SERIES_COLORS: string[] = [
		'#002554',   // Proyectos
		'#00c4b3',   // Ideografos
		'#05907E',   // Ideas
		'#ffc94d',   // Actividades
	];

	titulos = [
		{
			id: 9,
			title: "Creación de contenido",
		},
	];
	titulo: string = '';

	constructor(
		private translateService: TranslateService,
	) { }

	ngOnInit() {
		if (this.chart) {
			this.chart.destroy();
		}
		if(this.consultaID < 9){
			this.datasets = [this.obtenerLabelsConEstructura(this.datasetsImported, 0)];
		} else if(this.consultaID == 9){
			this.getDatasets(4);
		}
		this.labels = this.obtenerLabels(this.datasetsImported, 0);
		setTimeout(() => {
			this.createChart();
		}, 200);
	}

	getDatasets(cant_ds: number) {
		let labels = [];
		if(this.consultaID == 9){
			labels = ['Proyectos', 'Ideografos', 'Ideas', 'Actividades'];
		}
		for (let index = 0; index < cant_ds; index++) {
			const data = [];
			for (let index2 = 0; index2 < this.datasetsImported.length; index2++) {
				const element = this.datasetsImported[index2].data[index];
				data.push(element);
			}
			const newDataset = {
				label: labels[index],
				borderWidth: 1,
				data: data,
				backgroundColor: this.SERIES_COLORS[index % this.SERIES_COLORS.length],
			};
			this.datasets.push(newDataset);
		}
	}
	obtenerLabels(dataSets, index) {
		let filteredData;
		filteredData = dataSets
			.map(info => info.data[index])
			.filter(value => value !== null);
		return dataSets.map(info => info.label);
	}
	obtenerLabelsConEstructura(dataSets, index) {
		let filteredData;
		filteredData = dataSets
			.map(info => info.data[index])
			.filter(value => value !== null);
		const backgroundColor = filteredData.map((_, i) => this.getBarColor(i));
		return {
			label: '',
			data: filteredData,
			backgroundColor: backgroundColor,
		};
	}

	getBarColor(index: number): string {
		return this.CHART_COLORS[index % this.CHART_COLORS.length];
	}

	createChart() {
		this.titulo = this.titulos.find(t => t.id === this.consultaID)?.title || '';
		const canvas = this.chartCanvas?.nativeElement;
		if (!canvas) return;
		const ctx = canvas.getContext('2d');
		if (this.chart) {
			this.chart.destroy();
		}
		this.chart = new Chart(ctx, {
			type: 'bar',
			data: {
				labels: this.labels,
				datasets: this.datasets
			},
			options: {
				responsive: true,
				plugins: {
					title: {
						display: true,
						text: this.titulo,
						font: {
							size: 18,
							weight: 'bold'
						},
						padding: {
							top: 10,
							bottom: 20
						}
					},
					legend: {
						display: true,
						position: 'bottom',
					},
					filler: {
						propagate: true,
					},
					zoom: {
						zoom: {
							wheel: {
								enabled: false,
							},
							pinch: {
								enabled: false,
							},
							mode: 'x',
						},
						pan: {
							enabled: true,
							mode: 'x',
							scaleMode: 'x',
						},
					},
					tooltip: {
						callbacks: {
							label: function (context) {
								let label = context.dataset.label || '';
								if (label) {
									label += ': ';
								}
								label += context.raw;
								return label;
							}
						}
					}
				},
				scales: {
					x: {
						stacked: false,
						border: {
							display: true,
							color: '#000',
							width: 3
						},
						title: {
							display: false,
							text: this.titulo,
						},
					},
					y: {
						stacked: false,
						suggestedMin: 0,
						position: 'top',
						border: {
							display: true,
							color: '#000',
							width: 3
						},
						ticks: {
							callback: function (value) {
								return value;
							}
						}
					}
				},
				onClick: (event, elements) => {
					if (elements.length > 0) {
						const index = elements[0].index;
						const datasetIndex = elements[0].datasetIndex;
						this.verDetalle.emit({ datasetIndex, index });
					}
				}
			}
		});
	}

}
